import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { ComponentSwitcherDirective } from '@anecdotes/design-system/component-switcher';
import { ContactUsWidgetService } from '@anecdotes/support';

import { AccountFeatureEnum } from '@anecdotes/api-contracts';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-exclusive-feature-modal',
  templateUrl: './exclusive-feature-modal.component.html',
  styleUrls: ['./exclusive-feature-modal.component.scss'],
  standalone: false,
})
export class ExclusiveFeatureModalComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private accountFeature: AccountFeatureEnum;

  relativeTitleKey: string;
  icon: string;

  constructor(private contactUsWidget: ContactUsWidgetService, private switcher: ComponentSwitcherDirective) {}

  ngOnInit(): void {
    this.switcher.sharedContext$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((context: { feature: AccountFeatureEnum }) => {
        this.accountFeature = context.feature;
        this.buildIcon();
        this.buildRelativeTitleKey();
      });
  }

  buildTranslationKey(relativeKey: string): string {
    return `core.exclusiveFeatureModal.${relativeKey}`;
  }

  contactUs(): void {
    this.contactUsWidget.openContactUs();
  }

  private buildRelativeTitleKey(): void {
    const suffix = this.accountFeature.replace(' ', '');
    this.relativeTitleKey = `exclusive${suffix}`;
  }

  private buildIcon(): void {
    switch (this.accountFeature) {
      case AccountFeatureEnum.AdoptFramework:
        this.icon = 'apps/assets/img/exclusive-framework.png';
        break;
      case AccountFeatureEnum.PolicyTemplates:
      case AccountFeatureEnum.ExportControls:
        this.icon = 'apps/assets/img/exclusive-documents.png';
        break;
      default:
        break;
    }
  }
}
